import { useMutation } from '@tanstack/react-query'
import { useInvalidateQueries } from '../../../../../hooks/useInvalidateQueries'
import { addRequestsToArchive } from '../../../../../services/ApiService'
import { notifyError } from '../../../../../services/ToastifyService/ToastifyService'
import {
  closeModalFn,
  openModalFn,
} from '../../../../../utils/controllers/ModalController'
import getNoun from '../../../../../utils/utils/getNoun'

export const useSendToArchive = (checkboxStore: any) => {
  const invalidate = useInvalidateQueries()

  const { mutateAsync } = useMutation({
    mutationKey: ['add-to-archive'],
    mutationFn: () =>
      addRequestsToArchive({ orderIds: [...checkboxStore.selectedIds] }),
    onSuccess: () => {
      invalidate(['requests-table', 'get-requests-archive'])
      closeModalFn['progress-backdrop']?.()
    },
    onError: () => {
      closeModalFn['progress-backdrop']?.()
    },
  })

  const sendToArchive = () => {
    if (
      checkboxStore?.isForbiddenPaymentType ||
      checkboxStore.forbiddenPaymentCounts
    ) {
      notifyError('Запрещен для выбранного типа оплаты')
    } else {
      openModalFn['transaction-confirmation']?.({
        text1: `Подтвердить перемещение `,
        value1: `${checkboxStore?.selectedIds.length}`,
        text2: getNoun(
          checkboxStore?.selectedIds.length,
          'заявки в Архив?',
          'заявок в Архив?',
          'заявок в Архив?',
        ),
        action: mutateAsync,
        processText: `Выполняется перемещение ${
          checkboxStore?.selectedIds.length
        } ${getNoun(
          checkboxStore?.selectedIds.length,
          'заявки',
          'заявок',
          'заявок',
        )} в Архив`,
      })
    }
  }

  return { sendToArchive }
}
